<template>
    <ies-form-field :field="field">
        <v-radio-group
            v-model="viewValue"
            row
            autocomplete >
            <v-radio label=""    :value="0" ></v-radio>
            <v-radio label="*"   :value="1" ></v-radio>
            <v-radio label="**"  :value="2" ></v-radio>
            <v-radio label="***" :value="3" ></v-radio>
        </v-radio-group>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Allows the setting of a star rating via a radio button group
     */
    export default {
        name: 'ies-ratings',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                viewValue: parseInt(this.field.value),
            }
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
